module.exports = __webpack_public_path__ + "images/emoji/memo.4c38c528226a97549185.png";